import { Typography } from '@mui/material';
import { UseFormWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { IntakeRequestLineItem } from '../../IntakeRequestLineItemStep.schema';
import { I18nNamespace } from '~/common/types';

import { useTotalLineItemFormat } from './IntakeRequestStepLineItemTotal.hooks';

type IntakeRequestStepLineItemTotalProps = {
  watch: UseFormWatch<IntakeRequestLineItem>;
};
export const IntakeRequestStepLineItemTotal = ({ watch }: IntakeRequestStepLineItemTotalProps) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeRequestLineItemStepForm' });

  const [expectedPricePerUnit, quantity] = watch(['expectedPricePerUnit', 'quantity']);

  const { formatTotal } = useTotalLineItemFormat();
  return (
    <>
      <Typography variant="subtitle2" sx={{ marginTop: '8px' }} color="textSecondary">
        {t('totalValue')}
      </Typography>
      <Typography variant="h6">{formatTotal({ expectedPricePerUnit, quantity })}</Typography>
    </>
  );
};
